import React from "react";
import CustomLink from "../Link";

const AvatarDropdownMenu = ({ setOpenMenu }) => {
  return (
    <>
      <ul className="submenu">
        <li className="submenu_list" onClick={() => setOpenMenu(false)}>
          <CustomLink href="/user/my-profile" className="submenu_link">
            my profile
          </CustomLink>
        </li>
        <li className="submenu_list" onClick={() => setOpenMenu(false)}>
          <CustomLink href="/user/update-wallet" className="submenu_link">
            my wallet
          </CustomLink>
        </li>
        <li className="submenu_list" onClick={() => setOpenMenu(false)}>
          <CustomLink className="submenu_link">logout</CustomLink>
        </li>
      </ul>
    </>
  );
};

export default AvatarDropdownMenu;
